export class GoogleAnalyticsConstants {
  public static ANALYTICS_UID = 'UA-60572625-7';
}
